<template>
  <HeaderContent title="Admin" />
  <ActionContent
    ctaText="Add Admin"
    :filterDate="false"
    :filterModal="false"
    v-model:search="search"
    @action="modal = !modal"
    @search-query="searchData"
  />
  <AdminStatistics title="Admin Statistics" :data="statistics" />

  <AdminForm
    :modal="modal"
    :adminData="admin"
    @update:modal="updateModal"
    @addOrUpdate="getAll"
  />

  <AdminConfirm
    title="Confirmation"
    :uuid="adminUuid"
    @confirmed="deleteData"
    v-model="modalConfirm"
  >
    <template #text>Are you sure you want to delete this staff?</template>
  </AdminConfirm>

  <AdminDataTable
    :data="admins"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  />
</template>

<script>
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import AdminForm from "./AdminForm.vue";
import AdminDataTable from "@/components/DataTable.vue";
import AdminStatistics from "@/components/StatisticData.vue";
import AdminConfirm from "@/components/ModalDialog.vue";
// import iconLevel from '../../../public/icons/arrow-comparison.svg';
import iconUser from "../../../public/icons/users-alt.svg";
import { ref, inject, onMounted } from "vue";

export default {
  components: {
    HeaderContent,
    ActionContent,
    AdminForm,
    AdminDataTable,
    AdminStatistics,
    AdminConfirm,
  },
  setup() {
    const repositories = inject("repositories");
    const adminRepository = repositories.admin;

    const modal = ref(false);
    const modalConfirm = ref(false);
    const adminUuid = ref(null);
    const admin = ref({});
    const admins = ref([]);
    const search = ref("");

    const headers = ref([
      { key: "no", label: "No" },
      { key: "employee", label: "Name", class: "text-left" },
      { key: "username", label: "Username", class: "text-left" },
      { key: "email", label: "Email", class: "text-left" },
      { key: "role", label: "Level", class: "text-left" },
      {
        key: "status",
        label: "Status",
        sortable: true,
        class: "text-center",
        formater: (value) => {
          return value === "non-active" ? "Active" : "Inactive";
        },
      },
      { key: "action", label: "Actions" },
    ]);

    const statistics = ref([]);

    const customActions = ref([
      {
        label: "Non active data",
        variant: "warning",
        icon: "fas fa-user-slash",
        action: (item) => {
          console.log("Extra charge action clicked for:", item);
          // Implement your extra charge logic here
        },
      },
      {
        label: "Edit",
        variant: "success",
        icon: "fas fa-edit",
        action: (item) => {
          console.log("Edit action clicked for:", item);
          // Implement your edit logic here
          getById(item.uuid);
        },
      },
      {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
          console.log("Delete action clicked for:", item);
          // Implement your delete logic here
          adminUuid.value = item.uuid;
          modalConfirm.value = true;
        },
      },
    ]);

    const getAll = async (searchQuery = "") => {
      const params = {};
      if (searchQuery) params.search = searchQuery;
      try {
        const res = await adminRepository.getAll(params);
        admins.value = res.data.data.map((item, index) => ({
          ...item,
          no: index,
        }));
        statistics.value = [
          {
            label: "Total",
            key: "User",
            value: admins.value.length,
            color: "primary",
            icon: iconUser,
          },
        ];
      } catch (err) {
        console.error("Failed to fetch admin data:", err);
      }
    };

    const getById = async (uuid) => {
      try {
        const res = await adminRepository.getById(uuid);
        admin.value = res.data.data;
        modal.value = true;
      } catch (err) {
        console.error("Failed to get admin by ID:", err);
      }
    };

    const deleteData = async () => {
      try {
        await adminRepository.delete(adminUuid.value);
        modalConfirm.value = false;
        getAll();
      } catch (err) {
        console.error("Failed to delete staff:", err);
      }
    };

    const resetAdmin = () => {
      admin.value = {};
    };

    const updateModal = (newValue) => {
      modal.value = newValue;
      if (!newValue) resetAdmin();
    };

    function handleSearch(query) {
      search.value = query;
      getAll(query);
    }

    const searchData = async (query) => {
      getAll(query);
    };

    onMounted(() => {
      getAll();
    });

    return {
      modal,
      modalConfirm,
      adminUuid,
      admin,
      admins,
      headers,
      statistics,
      customActions,
      getAll,
      deleteData,
      resetAdmin,
      getById,
      updateModal,
      search,
      handleSearch,
      searchData,
    };
  },
};
</script>
